var success = function (name) { return name + "_FULFILLED"; };
var pending = function (name) { return name + "_PENDING"; };
var error = function (name) { return name + "_REJECTED"; };
export { success, pending, error, };
